export const config = {
	btn: {
		outlined: true,
		color: 'primary',
		class: 'text-wrap',
		minHeight: '36px',
		height: 'auto'
	},
	icon: {
		color: 'primary',
		class: 'mr-3'
	}
};
